import React from 'react';
import type { WriterDocState } from '@/hooks/useWriterDocState';

export const DOC_STATE_LABEL: Record<WriterDocState, string> = {
  clean: 'Up to date',
  dirty: 'Pending changes',
  materializing: 'Snapshotting…',
  compiling: 'Compiling…',
  success: 'Up to date',
  failed: 'Compile failed',
};

export const DOC_STATE_TONE: Record<WriterDocState, string> = {
  clean: 'text-muted-foreground',
  dirty: 'text-amber-600 dark:text-amber-400',
  materializing: 'text-sky-600 dark:text-sky-400',
  compiling: 'text-sky-600 dark:text-sky-400',
  success: 'text-emerald-600 dark:text-emerald-400',
  failed: 'text-destructive',
};

export const DocStateChip: React.FC<{ docState: WriterDocState | null }> = ({
  docState,
}) => {
  if (!docState) return null;
  return (
    <span
      className={`text-[10px] uppercase tracking-widest ${DOC_STATE_TONE[docState]}`}
      aria-live="polite"
    >
      {DOC_STATE_LABEL[docState]}
    </span>
  );
};
